import React from "react";
import Footer from "../components/footer";
import Header from "../components/header";

export default function Subscription() {
  const plans = [
    {
      id: 1,
      name: "Temel Paket",
      price: "49.90",
      billedAs: "420",
      discount: "30",
      features: [
        "Sınırsız üye",
        "Sınırsız geri bildirim",
        "Haftalık Ekip Geri Bildirim Cuması",
        "Özel +9 Avatar",
        "Ekip geri bildirim geçmişi",
      ],
      isFeatured: false,
    },
    {
      id: 2,
      name: " Premium Paket",
      price: "149.90",
      billedAs: "1.259",
      discount: "30",
      features: [
        "Sınırsız üye",
        "Sınırsız geri bildirim",
        "Haftalık Ekip Geri Bildirim Cuması",
        "Özel +9 Avatar",
        "Ekip geri bildirim geçmişi",
      ],
      isFeatured: true,
    },
    {
      id: 3,
      name: "Gelişmiş Paket",
      price: "99.90",
      billedAs: "839",
      discount: "30",
      features: [
        "Sınırsız üye",
        "Sınırsız geri bildirim",
        "Haftalık Ekip Geri Bildirim Cuması",
        "Özel +9 Avatar",
        "Ekip geri bildirim geçmişi",
      ],
      isFeatured: false,
    },
  ];

  const comparisonData = {
    headers: ["Özellikler", "Temel Paket", "Gelişmiş Paket", "Premium Paket"],
    pricing: ["", "49.90₺ / aylık", "99.90₺ / aylık", "149.90₺ / aylık"],
    categories: [
      {
        features: [
          {
            name: "Analitik",
            availability: [],
          },
          {
            name: "Gerçek zamanlı analitik",
            availability: [true, true, true],
          },
          {
            name: "Kullanıcı analitiği",
            availability: [false, true, true],
          },
          {
            name: "Huni optimizasyonu",
            availability: [false, true, true],
          },
          {
            name: "Raporlama",
            availability: [],
          },
          {
            name: "Otomatik",
            availability: [false, true, true],
          },
          {
            name: "Yapay zeka veri tahminleri",
            availability: [true, true, false],
          },
          {
            name: "Gelişmiş grafikler",
            availability: [false, true, false],
          },
          {
            name: "Güvenlik",
            availability: [],
          },
          {
            name: "Gerçek zamanlı ekip raporları",
            availability: [false, true, true],
          },
          {
            name: "Kolay paylaşılabilir sonuçlar",
            availability: [true, true, true],
          },
          {
            name: "Ekip hedef belirleme",
            availability: [false, true, true],
          },
        ],
      },
    ],
  };

  // Tik işareti SVG komponenti
  const CheckIcon = ({ className }) => (
    <img
      src="/assets/Tick.svg"
      alt="Check"
      className={className}
      loading="lazy"
    />
  );

  // Çarpı işareti SVG komponenti
  const CrossIcon = ({ className }) => (
    <img
      src="/assets/Close.svg"
      alt="Cross"
      className={className}
      loading="lazy"
    />
  );

  const boldFeatures = ["Sınırsız geri bildirim", "Özel +9 Avatar"];

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Header */}
      <Header isHomePage={false} />

      {/* Hero Section */}

      <section className="relative w-full h-[440px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/assets/subscription.png"
            alt="Keşfet"
            className="w-full h-full object-cover object-center"
            loading="lazy"
          />
        </div>
        <div className="absolute inset-0 flex items-end">
          <div className="container mx-auto px-4 sm:px-6 md:px-8 pb-4 sm:pb-8 md:pb-12 lg:pb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-[54px] font-medium font-poppins text-white text-center sm:text-left max-w-xs sm:max-w-sm md:max-w-2xl mx-auto sm:mx-0">
              Abonelikler
            </h2>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="container mx-auto px-4 py-6 sm:py-8 md:py-12 lg:py-16">
        <div className="max-w-6xl mx-auto">
          <h1 className=" text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-[#2F327D] mb-3 sm:mb-4 md:mb-6 lg:mb-8 text-center font-poppins max-w-[1081px]">
            Abonelikler
          </h1>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-[#797979] mb-4 sm:mb-6 md:mb-8 lg:mb-10 text-center font-poppins max-w-[1171px]">
            Premium üyelerimiz, platformumuzda paylaşılan tüm özel içeriklere
            sınırsız erişim sağlar.
          </p>
        </div>
      </section>

      {/* Plans section */}
      <section className="  ">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-8">
            {plans.map((plan) => (
              <div
                key={plan.id}
                className={`card w-[346px] h-[582px] flex flex-col justify-between
                  ${plan.isFeatured ? "bg-[#FF8293]" : "bg-white"}
                   shadow-xl hover:shadow-2xl transition-shadow duration-300 rounded-[30px] p-8`}
              >
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <h2
                      className={`text-xl font-medium font-poppins 
                        ${
                          plan.isFeatured ? "text-[#f9f9f9]" : "text-[#242331]"
                        }`}
                    >
                      {plan.name}
                    </h2>
                    <span
                      className={`rounded-[39px] px-4 py-2 text-sm font-semibold font-poppins 
                        ${
                          plan.isFeatured
                            ? "bg-white text-black"
                            : "bg-white text-black ring-1 ring-inset ring-gray-200"
                        }`}
                    >
                      %{plan.discount} İndirim
                    </span>
                  </div>

                  <div className="flex items-baseline justify-start gap-1 my-6">
                    <span
                      className={`text-4xl font-bold ${
                        plan.isFeatured ? "text-[#f9f9f9]" : "text-[#242331]"
                      }`}
                    >
                      {plan.price}₺
                    </span>
                    <span
                      className={`text-lg font-poppins font-normal 
                        ${plan.isFeatured ? "text-[#f9f9f9]" : "text-black"}`}
                    >
                      / aylık
                    </span>
                  </div>
                  <hr
                    className={`border-t-[0.5px] my-6 
                    ${
                      plan.isFeatured ? "border-pink-200" : "border-[#D3D3D3]"
                    }`}
                  />
                  <div
                    className={`rounded-[20px] px-4 py-3 mb-6 max-w-full mx-auto 
                      ${plan.isFeatured ? "bg-[#E0E7F9]" : "bg-indigo-100"}`}
                  >
                    <p
                      className={`text-sm text-center font-nunito font-semibold 
                        ${
                          plan.isFeatured
                            ? "text-indigo-700"
                            : "text-indigo-700"
                        }`}
                    >
                      Yıllık {plan.billedAs}₺ olarak faturalandırılır
                    </p>
                  </div>
                  <hr
                    className={`border-t-[0.5px] my-6 
                    ${
                      plan.isFeatured ? "border-pink-200" : "border-[#D3D3D3]"
                    }`}
                  />

                  <ul className="space-y-3 mb-8 text-left">
                    {plan.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <span
                          className={`text-sm font-nunito text-left 
                            ${
                              plan.isFeatured
                                ? "text-[#f9f9f9]"
                                : "text-[#797979]"
                            }
                            ${
                              boldFeatures.includes(feature)
                                ? "font-bold"
                                : "font-normal"
                            }`}
                        >
                          {feature}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="card-actions mt-auto">
                  <button
                    className={`btn btn-block rounded-[39px] px-4 py-3 font-bold font-nunito text-lg transform hover:scale-105 transition-transform duration-300 
                      ${
                        plan.isFeatured
                          ? "bg-white text-[#FF8293] border-transparent hover:bg-[#FF8293] hover:text-white"
                          : plan.id === 3
                          ? "bg-transparent text-[#242331] border border-[#D3D3D3] hover:bg-[#1D1E28] hover:text-white"
                          : "bg-white text-[#242331] border border-[#D3D3D3] hover:bg-[#242331] hover:text-white"
                      }`}
                    onClick={() =>
                      (window.location.href =
                        plan.id === 1
                          ? "/plans/basic-plan"
                          : plan.id === 2
                          ? "/plans/premium-plan"
                          : "/plans/advanced-plan")
                    }
                  >
                    Hemen Başla
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Packages Section */}
      <section className="container mx-auto px-4 py-6 sm:py-8 md:py-12 lg:py-24">
        <div className=" max-w-[1172px] mx-auto ">
          <h1 className=" text-2xl sm:text-2xl md:text-3xl lg:text-[40px] font-semibold text-[#2F327D] mb-3 sm:mb-4 md:mb-12 lg:mb-32 text-center font-poppins">
            Fiyatlandırma paketlerini karşılaştırın
          </h1>

          {/* Desktop Table - Mobilde gizlenecek */}
          <div className="hidden md:block shadow-lg">
            <div className="overflow-x-auto border-[0.5px]rounded-[50px]">
              <table className="w-full">
                <thead className="bg-[#f9f9f9]">
                  <tr>
                    {comparisonData.headers.map((header, index) => (
                      <th
                        key={index}
                        className={`p-8 py-5 text-center font-nunito font-extrabold text-[28px] text-[#242331]leading-tight ${
                          index === 0
                            ? "translate-y-[35px] translate-x-[-65px] text-left"
                            : ""
                        }`}
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    {comparisonData.pricing.map((price, index) => (
                      <td
                        key={index}
                        className={`p-8 py-5 font-medium font-nunito text-base text-[#242331] ${
                          index === 0 ? "text-left" : "text-center"
                        }`}
                      >
                        {price}
                      </td>
                    ))}
                  </tr>
                </thead>
                <tbody className="border-t-[0.5px] border-[#D3D3D3]">
                  {comparisonData.categories.map((category, categoryIndex) => (
                    <React.Fragment key={categoryIndex}>
                      {category.features.map((feature, featureIndex) => (
                        <tr
                          key={featureIndex}
                          className={`${
                            featureIndex % 2 === 0 ? "bg-white" : "bg-[#f9f9f9]"
                          }`}
                        >
                          <td className="py-4 px-12 h-[96px] font-nunito text-xl text-left font-medium ">
                            <p
                              className={`max-w-[176px] ${
                                feature.availability.length
                                  ? "text-[#797979] font-medium"
                                  : "text-[#E94057] font-semibold font-nunito text-xl"
                              }`}
                            >
                              {feature.name}
                            </p>
                          </td>
                          {feature.availability.map(
                            (isAvailable, planIndex) => (
                              <td
                                key={planIndex}
                                className="py-4 px-6 text-center"
                              >
                                <div className="flex justify-center items-center h-full">
                                  {isAvailable ? (
                                    <CheckIcon className="h-5 w-5" />
                                  ) : (
                                    <CrossIcon className="h-5 w-5" />
                                  )}
                                </div>
                              </td>
                            )
                          )}
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                  <tr>
                    <td className="p-8"></td>
                    {[1, 2, 3].map((_, index) => (
                      <td key={index} className="p-8 text-center">
                        <button
                          className={`btn border border-[#D3D3D3] rounded-[39px] px-8 py-3 font-bold font-nunito text-lg transform hover:scale-105 transition-transform duration-300 ${
                            index === 2
                              ? "bg-[#242331] text-white"
                              : "bg-white text-[#242331]"
                          }`}
                          onClick={() =>
                            (window.location.href =
                              index === 0
                                ? "/plans/basic-plan"
                                : index === 1
                                ? "/plans/advanced-plan"
                                : "/plans/premium-plan")
                          }
                        >
                          Hemen Başla
                        </button>
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobil Kartlar */}
          <div className="md:hidden space-y-8 ">
            {comparisonData.headers.slice(1).map((header, index) => (
              <div
                key={index}
                className="bg-white rounded-[20px] p-6 shadow-lg border-[0.1px] border-[#D3D3D3]"
              >
                {/* Kart Başlığı */}
                <div className="text-center mb-6">
                  <h3 className="font-nunito font-extrabold text-2xl text-[#242331] mb-2">
                    {header}
                  </h3>
                  <p className="font-nunito text-base text-[#242331]">
                    {comparisonData.pricing[index + 1]}
                  </p>
                </div>

                {/* Özellikler Listesi */}
                <div className="space-y-4">
                  {comparisonData.categories[0].features.map(
                    (feature, featureIndex) => (
                      <div
                        key={featureIndex}
                        className={`flex items-center gap-3 p-3 rounded-md ${
                          !feature.availability.length
                            ? "bg-white border-t border-b border-[#e9e9e9]"
                            : featureIndex % 2 === 0
                            ? "bg-white"
                            : "bg-white"
                        }`}
                      >
                        <span
                          className={`font-nunito text-base font-medium flex-grow ${
                            !feature.availability.length
                              ? "text-[#E94057] font-semibold"
                              : "text-[#797979]"
                          }`}
                        >
                          {feature.name}
                        </span>
                        {feature.availability.length > 0 && (
                          <div className="flex-shrink-0">
                            {feature.availability[index] ? (
                              <CheckIcon className="h-5 w-5 text-green-500" />
                            ) : (
                              <CrossIcon className="h-5 w-5 text-red-500" />
                            )}
                          </div>
                        )}
                      </div>
                    )
                  )}
                </div>

                {/* Buton */}
                <div className="mt-8 text-center">
                  <button
                    className={`w-full border border-[#D3D3D3] rounded-[39px] px-8 py-3 font-bold font-nunito text-lg transform hover:scale-105 transition-transform duration-300 ${
                      index === 2
                        ? "bg-[#242331] text-white"
                        : "bg-white text-[#242331]"
                    }`}
                    onClick={() =>
                      (window.location.href =
                        index === 0
                          ? "/plans/basic-plan"
                          : index === 1
                          ? "/plans/advanced-plan"
                          : "/plans/premium-plan")
                    }
                  >
                    Hemen Başla
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer isHomePage={false} />
    </div>
  );
}
